import React from 'react'
import { NavLink } from 'react-router-dom'
import { IoMdHome } from "react-icons/io";

function NotFound() {
    return (
        <div className='w-full min-h-[calc(100vh-68px)] bg-notFound bg-no-repeat bg-cover bg-fixed inset-0 justify-center items-center flex absolute'>
            <div className="w-full min-h-[calc(100vh-68px)] mx-auto flex flex-col justify-around items-center text-white">
                <div className="flex flex-col justify-center items-center">
                    <p className='montserrat-alternates-bold opacity-50 text-lg'>Oppss..!</p>
                    <h1 className="text-9xl days-one-bold opacity-50">404</h1>
                </div>
                <div className="flex flex-col justify-center items-center">
                    <h1 className="text-3xl montserrat-alternates-bold">Sayfa Bulunamadı!</h1>
                    <p className="text-sm mt-2 montserrat-alternates-regular">Aradığınız sayfa mevcut değil. Biraz dinlenmeniz gerekiyor olabilir..</p>
                </div>
                <NavLink to="/home" className="bg-transparent border border-slate-200 text-white py-2 px-8 rounded-lg hover:bg-slate-200 hover:text-black font-medium transition-all montserrat-alternates-regular text-xs flex flex-row items-center justify-center">
                    <IoMdHome className="inline-block mr-1" size={'16px'} />
                    Anasayfaya Dön
                </NavLink>
            </div>
        </div>
    )
}

export default NotFound
